import type { Bc3ImportPlan } from "./bc3ImportPlan";
const informational=new Set([
 "Há recursos percentuais: a base de cálculo precisa de validação específica.",
 "Existem várias tarifas; todas são preservadas, sem escolher automaticamente uma.",
 "O ficheiro contém medições; não são aplicadas a propostas nesta pré-visualização.",
]);
export function selectedBc3Import(plan:Bc3ImportPlan,codes:string[]):Bc3ImportPlan {
 const selected=new Set(codes);
 if(selected.size!==codes.length || !selected.size || selected.size>500)throw new Error("Selecione entre 1 e 500 artigos diferentes.");
 const articles=plan.articles.filter(article=>selected.has(article.code));
 if(articles.length!==selected.size || articles.some(article=>article.blockers.length))throw new Error("A seleção contém artigos por resolver.");
 const blockers=plan.blockers.filter(warning=>!informational.has(warning));
 if(blockers.length)throw new Error("Resolva as observações do ficheiro antes de importar.");
 return {...plan,articles,blockers};
}
export function bc3OriginalBase64(bytes:ArrayBuffer):string {
 if(bytes.byteLength<1 || bytes.byteLength>8*1024*1024)throw new Error("Escolha um ficheiro até 8 MB.");
 const values=new Uint8Array(bytes);const chunks:string[]=[];
 for(let offset=0;offset<values.length;offset+=8192)chunks.push(String.fromCharCode(...values.subarray(offset,offset+8192)));
 return btoa(chunks.join(""));
}
